/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiMovementOrderIc.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-movement-order-ic";

export class AutogenModelEdiMovementOrderIc<RowType extends ModelRow> extends Endpoint<RowType, RowEdiMovementOrderIcFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiMovementOrderIc extends ModelRow<RowEdiMovementOrderIcFields> {
	constructor(values?: Partial<RowEdiMovementOrderIcFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiMovementOrderIcFields {
	brokerage: string;
	brokerage_sequence: string;
	dest_stop_id: string;
	dis_user_email: string;
	dis_user_ext: string;
	dis_user_name: string;
	dis_user_phone: string;
	"edi_movement_order.accepted_date": Date;
	"edi_movement_order.brokered_sequence": number;
	"edi_movement_order.company_id": string;
	"edi_movement_order.has_receiving_error": string;
	"edi_movement_order.has_sending_error": string;
	"edi_movement_order.id": string;
	"edi_movement_order.intercompany_key": string;
	"edi_movement_order.receiving_company_id": string;
	"edi_movement_order.receiving_company_move_id": string;
	"edi_movement_order.receiving_company_order_id": string;
	"edi_movement_order.sending_company_id": string;
	"edi_movement_order.sending_company_move_id": string;
	"edi_movement_order.sending_company_order_id": string;
	"edi_movement_order.settled_date": Date;
	"edi_movement_order.shipment_id": string;
	"edi_movement_order.submitted_date": Date;
	error_desc: string;
	error_id: string;
	error_type: string;
	in_invoice_errors: string;
	in_status_errors: string;
	in_tender_errors: string;
	move_status: string;
	movement_id: string;
	ops_user_email: string;
	ops_user_ext: string;
	ops_user_name: string;
	ops_user_phone: string;
	origin_stop_id: string;
	out_invoice_errors: string;
	out_status_errors: string;
	out_tender_errors: string;
	reply_status: string;
	role: string;
	settled_date: string;
	shared_co_carrier_contact: string;
	shared_co_carrier_email: string;
	shared_co_carrier_name: string;
	shared_co_carrier_phone: string;
	shared_co_driver: string;
	shared_co_driver2: string;
	shared_co_driver2_email: string;
	shared_co_driver2_phone: string;
	shared_co_driver_email: string;
	shared_co_driver_phone: string;
	shared_co_stops: string;
	shared_co_tractor: string;
	shared_co_trailer: string;
	shared_co_trailer_type: string;
	shared_company: string;
	shared_order_id: string;
	shared_shipment_id: string;
	ss_act_arrival: string;
	ss_act_departure: string;
	ss_address: string;
	ss_arrive_early: string;
	ss_arrive_late: string;
	ss_city_id: string;
	ss_city_name: string;
	ss_company_id: string;
	ss_location_id: string;
	ss_location_name: string;
	ss_movement_seq: string;
	ss_order_seq: string;
	ss_state: string;
	ss_status: string;
	ss_stop_id: string;
	ss_stop_type: string;
	ss_zip_code: string;
	status_desc: string;
	submitted_date: string;
	order_id: string;
}

